import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, SERVICES_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'allService',
  url: `${SERVICES_URL}/all`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
